import { Typography } from "@mui/material";

interface IDepositMinimumDisclaimerProps {
  tokenCode: string;
}

export default function DepositMinimumDisclaimer({ tokenCode }: IDepositMinimumDisclaimerProps) {
  let depositMin = "USD 0.02 in value";
  if (tokenCode === "HBAR") {
    depositMin = "10 HBAR";
  }

  return (
    <Typography style={{ fontSize: "12px", lineHeight: "14px", color: "#7B858B" }} my={3}>
      All deposits <b>must be greater than {depositMin}</b>. Any deposits below this threshold will
      be ignored
    </Typography>
  );
}
